import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ManageBankAccountWidget from '../../../widgets/manageBankAccountWidget/ManageBankAccountWidget'
import '../styles.less'
import { getManageBankAccount } from '../../../redux/actions/manageBankAccount'

//จัดการบัญชีธนาคาร
export default function ManageBankAccount() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')

  useEffect(() => {
    handleGetSchema(projectCode)
  }, [])

  const handleGetSchema = async (projectCode) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getManageBankAccount(projectCode)
      // console.log('response ', response)
      // response.model.disabled = true
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <ManageBankAccountWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}
